
<div *ngIf="state === 'ready'">

       <div style="text-align: center; margin-left: 100px; margin-right: 100px;">
              <p><i>System Config values are used for applicartion startup and presented as GLOBAL variables within the application.
              </i></p>
       </div>
       <hr />

        <form [formGroup]="systemConfigFormGroup" (ngSubmit)="onSubmit()">
                <input type="number" 
                        formControlName="id"                
                        name="id"
                        #id 
                        hidden>
                <br />
                <br />                

                <label for="name">Act/Bud Ledger Name: </label>
                <input type="text" 
                       formControlName="actBudLedgerName"
                       name="actBudLedgerName"
                       #actBudLedgerName>                
                <br />
                <br />
                
                <label for="name">Budget Year: </label>
                <input type="number" 
                       formControlName="budgetYear"
                       name="budgetYear"
                       #budgetYear>                
                <br />
                <br />  
                <label for="name">Default Calculation View: </label>
                <input type="text" 
                       formControlName="defaultCalculationView"
                       name="defaultCalculationView"
                       #defaultCalculationView>                
                <br />
                <br />  

                <label for="name">FP Ledger Name: </label>
                <input type="text" 
                       formControlName="fpLedgerName"
                       name="fpLedgerName"
                       #fpLedgerName>                
                <br />
                <br />  

                <label for="name">Payroll Cash Pay Days Per Month: <br /><span style="font-size: smaller; font-weight: bold;">(seperated by a comma)</span></label>
                <input type="text" 
                       formControlName="payrollCashPayDaysPerMonth"
                       name="payrollCashPayDaysPerMonth"
                       #payrollCashPayDaysPerMonth>                
                <br />
                <br />  

                <label for="name">Payroll Exempt Salary Threshold: </label>
                <input type="number" 
                       formControlName="payrollExemptSalaryThreshold"
                       name="payrollExemptSalaryThreshold"
                       #payrollExemptSalaryThreshold>                
                <br />
                <br />  

                <label for="name">Payroll Split Accounts: <br /><span style="font-size: smaller; font-weight: bold;">(seperated by a comma)</span></label>
                <textarea type="text" 
                       formControlName="payrollSplitAccounts"
                       name="payrollSplitAccounts"
                       rows="4"
                       #payrollSplitAccounts>
                </textarea>                
                <br />
                <br />  

                <label for="name">Special Accounts Gain Loss To Lease: </label>
                <input type="text" 
                       formControlName="specialAccountsGainLossToLease"
                       name="specialAccountsGainLossToLease"
                       #specialAccountsGainLossToLease>                
                <br />
                <br />  

                <label for="name">Special Accounts Gpr: </label>
                <input type="text" 
                       formControlName="specialAccountsGpr"
                       name="specialAccountsGpr"
                       #specialAccountsGpr>                
                <br />
                <br />  

                <label for="name">Special Accounts Vacancy Loss: </label>
                <input type="text" 
                       formControlName="specialAccountsVacancyLoss"
                       name="specialAccountsVacancyLoss"
                       #specialAccountsVacancyLoss>                
                <br />
                <br />  
        
                <div style="margin-top: 10px;">
                    <button type="submit" >Save</button>
                </div>
            </form>
</div>
